import { render } from "./Starred.vue?vue&type=template&id=3e566e7b"
import script from "./Starred.vue?vue&type=script&lang=js"
export * from "./Starred.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__